import api from '@/services/api'
import { getOptionsString } from '@/services/api/helpers'

const createAdCreativeAudio = (path, payload) => {
  return api.post(path, payload).then(async ({data}) => {
    return data
  })
}

const getAdCreative = (path) => {
  return api.get(path).then(async ({data}) => {
    return data
  })
}

const getAdCreatives = (path, options) => {
  return api.get(`${path}&${getOptionsString(options)}`).then(async ({data}) => {
    return data
  })
}

const updateAdCreative = (path, payload) => {
  return api.post(path, payload).then(async ({data}) => {
    return data
  })
}

export default {
  createAdCreativeAudio,
  getAdCreative,
  getAdCreatives,
  updateAdCreative
}
